<template>
  <span>
    <div v-if="$apollo.loading">
      {{ $t("common:loading.messsage", "Loading...", "Loading message") }}
    </div>
    <component
      :is="noLink ? 'div' : 'router-link'"
      v-else-if="displayOrganisation"
      :to="{
        name: 'OrganisationProfilePage',
        params: { organisationId: displayOrganisation.id }
      }"
      :class="muted ? 'muted--text' : ''"
      class="no-default-link-style"
    >
      {{
        shortName
          ? displayOrganisation.shortName || displayOrganisation.name
          : displayOrganisation.name
      }}
    </component>
  </span>
</template>
<script>
// Need to convert it to AppShowOrganisationName
import gql from "fraql";

export default {
  name: "AppOrganisationNameLink",
  props: {
    organisation: {
      type: [Object, String],
      default: null
    },
    shortName: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: false
    },
    noLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      queriedOrganisation: null
    };
  },
  computed: {
    displayOrganisation() {
      if (
        typeof this.organisation === "string" ||
        this.organisation instanceof String
      ) {
        return this.queriedOrganisation || { id: this.organisation };
      } else {
        return this.organisation;
      }
    }
  },
  fragments: {
    organisation: gql`
      fragment _ on Organisation {
        id
        name
        fullName
        shortName
      }
    `
  },
  apollo: {
    queriedOrganisation: {
      query: gql`
        query organisationNameLink($id: ID) {
          organisation(id: $id) {
            id
            name
            shortName
          }
        }
      `,
      variables() {
        return {
          id: this.organisation
        };
      },
      skip() {
        return !(
          typeof this.organisation === "string" ||
          this.organisation instanceof String
        );
      },
      update(data) {
        return data.organisation;
      }
    }
  }
};
</script>
